import React from 'react';
import { Divider } from 'components';
import styled from 'styled-components';
import type { Task } from '@/app-package';
import { TaskLayoutContainer } from './TaskLayout';
import HeaderText from './HeaderText';
import AssignLockboxItem from './AssignLockboxItem';

type AssignLockboxTasksSectionProps = { tasks: Task[] };

const AssignLockboxTasksSection = ({
  tasks,
}: AssignLockboxTasksSectionProps) => (
    <>
      {tasks.length ? (
        <>
          <TaskLayoutContainer>
            <HeaderText level={5}>{'Assign Lockbox'}</HeaderText>
            {tasks.map((item, index) => (
              <>
                <AssignLockboxItem key={index} itemData={item.data} />
                {index !== tasks.length - 1 && <Spacer />}
              </>
            ))}
          </TaskLayoutContainer>
          <Divider style={{ margin: 0 }} />
        </>
      ) : null}
    </>
  );

const Spacer = styled.div`
  padding-bottom: 1px;
`;

export default AssignLockboxTasksSection;
